"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_TIMEOFF_API = exports.GET_PAYRATES_API = exports.GET_PAYCALENDAR_API = exports.ApiRoot = void 0;
var query_string_1 = require("query-string");
var ApiRoot;
(function (ApiRoot) {
    ApiRoot["PayCalendar"] = "/payCalendar";
    ApiRoot["PayRates"] = "/payRates";
    ApiRoot["Timeoff"] = "/timeoff/requests/cached";
})(ApiRoot = exports.ApiRoot || (exports.ApiRoot = {}));
var parseQueryParameters = function (params) {
    var parsedParams = (0, query_string_1.stringify)(params);
    return parsedParams ? "?".concat(parsedParams) : '';
};
var GET_PAYCALENDAR_API = function (employeeId, startDate, endDate) {
    var queryParams = parseQueryParameters({
        employeeId: employeeId,
        startDate: startDate,
        endDate: endDate
    });
    return "".concat(ApiRoot.PayCalendar).concat(queryParams);
};
exports.GET_PAYCALENDAR_API = GET_PAYCALENDAR_API;
var GET_PAYRATES_API = function (employeeId) {
    var queryParams = parseQueryParameters({ employeeId: employeeId });
    return "".concat(ApiRoot.PayRates).concat(queryParams);
};
exports.GET_PAYRATES_API = GET_PAYRATES_API;
var GET_TIMEOFF_API = function (employeeId, startDate, endDate) {
    var queryParams = parseQueryParameters({
        employeeId: employeeId,
        rangeStart: startDate,
        rangeEnd: endDate
    });
    return "".concat(ApiRoot.Timeoff).concat(queryParams);
};
exports.GET_TIMEOFF_API = GET_TIMEOFF_API;
